/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultReferentialVariable } from '../../models/api-response-paged-result-referential-variable';
import { PagedRequestVariableSearch } from '../../models/paged-request-variable-search';

export interface SearchReferentialVariable$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestVariableSearch
}

export function searchReferentialVariable(http: HttpClient, rootUrl: string, params: SearchReferentialVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialVariable>> {
  const rb = new RequestBuilder(rootUrl, searchReferentialVariable.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultReferentialVariable>;
    })
  );
}

searchReferentialVariable.PATH = '/v1/api/admin-ui/referential/variable/search';
